export class TimeoutError extends Error {
    constructor() {
        super("Task timed out");
        this.name = "TimeoutError";
    }
}
export const timeout = (ms, p) => {
    let timer;
    return Promise.race([
        p.finally(() => clearTimeout(timer)),
        new Promise((_, reject) => {
            timer = setTimeout(() => reject(new TimeoutError()), ms);
        }),
    ]);
};
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const all = (promises) => Promise.all(promises);
export const defer = () => {
    const deferred = {
        status: { type: "pending" },
        promise: null,
        resolve: () => { },
        reject: () => { },
    };
    deferred.promise = new Promise((resolve, reject) => {
        deferred.resolve = (value) => {
            if (deferred.status.type !== "pending")
                return;
            deferred.status = { type: "resolved", value };
            resolve(value);
        };
        deferred.reject = (error) => {
            if (deferred.status.type !== "pending")
                return;
            deferred.status = { type: "rejected", error };
            reject(error);
        };
    });
    return deferred;
};
//# sourceMappingURL=index.js.map